import React from "react";
import { Sparkles, Heart } from "lucide-react";
import { IMAGES, RATING } from "@/lib/site";
import { Reveal, Overline } from "@/components/site/Reveal";

export const About = () => {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative py-24 md:py-36 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Visual Images Composition */}
        <div className="lg:col-span-6 relative">
          <div className="relative aspect-[4/5] w-[84%] overflow-hidden rounded-[2rem] shadow-soft-lg border-2 border-white/80 bg-clinic-pinkSoft/30">
            <img
              src={IMAGES.founder}
              alt="Lília Targa — profissional e fundadora da clínica"
              loading="lazy"
              decoding="async"
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-clinic-ink/80 via-clinic-ink/40 to-transparent p-6 pt-20">
              <div className="flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-clinic-pink" />
                <p className="font-serif text-2xl text-white font-medium leading-none">Lília Targa</p>
              </div>
              <p className="font-sans text-xs tracking-[0.25em] uppercase text-white/80 mt-2">
                Especialista em Saúde & Beleza
              </p>
            </div>
          </div>


          {/* Secondary Layered Image */}
          <Reveal
            delay={0.2}
            className="absolute right-0 bottom-0 w-[50%] aspect-square overflow-hidden rounded-[1.75rem] border-8 border-clinic-bg shadow-soft-lg bg-clinic-pinkSoft/50"
          >
            <img
              src={IMAGES.reception}
              alt="Ambiente e recepção da Clínica Lília Targa em Jundiaí"
              loading="lazy"
              decoding="async"
              className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
            />
          </Reveal>
        </div>

        {/* Informative Text & Metrics */}
        <div className="lg:col-span-6">
          <Reveal>
            <Overline index="01">Sobre a Clínica</Overline>
          </Reveal>
          
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-clinic-ink">
              Um cuidado inteiro,
              <br />
              <span className="italic text-clinic-rose font-normal">só para você</span>
            </h2>
          </Reveal>

          <Reveal delay={0.2}>
            <p className="mt-8 font-sans text-base md:text-lg text-clinic-muted leading-relaxed max-w-xl">
              Na Clínica Lília Targa, acreditamos que a verdadeira beleza reflete
              o bem-estar e o cuidado individual. Unimos conhecimento técnico,
              sensibilidade e produtos de alta tecnologia para proporcionar uma
              experiência estética acolhedora e eficaz.
            </p>
          </Reveal>

          <Reveal delay={0.3}>
            <p className="mt-5 font-sans text-base text-clinic-muted leading-relaxed max-w-xl">
              Cada tratamento é cuidadosamente planejado para atender às suas
              expectativas e particularidades, sempre em um ambiente tranquilo e
              sofisticado no coração de Jundiaí.
            </p>
          </Reveal>

          {/* Metric Highlights */}
          <Reveal delay={0.4}>
            <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-6 max-w-lg">
              <div className="glass-card rounded-2xl border border-clinic-line/80 p-5 shadow-sm">
                <p className="font-serif text-4xl text-clinic-ink font-medium">{RATING}</p>
                <p className="font-sans text-xs text-clinic-muted mt-1.5 leading-snug">
                  Nota máxima no Google Reviews
                </p>
              </div>
              <div className="glass-card rounded-2xl border border-clinic-line/80 p-5 shadow-sm">
                <p className="font-serif text-4xl text-clinic-rose font-medium">100%</p>
                <p className="font-sans text-xs text-clinic-muted mt-1.5 leading-snug">
                  Atendimento individualizado
                </p>
              </div>
              <div className="glass-card rounded-2xl border border-clinic-line/80 p-5 shadow-sm col-span-2 sm:col-span-1">
                <div className="flex items-center gap-1">
                  <Heart className="h-5 w-5 text-clinic-rose" />
                  <p className="font-serif text-2xl text-clinic-ink font-medium">Jundiaí</p>
                </div>
                <p className="font-sans text-xs text-clinic-muted mt-1.5 leading-snug">
                  Espaço acolhedor e exclusivo
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

